import { render, staticRenderFns } from "./LatestActivity.vue?vue&type=template&id=437ef930"
import script from "./LatestActivity.vue?vue&type=script&lang=js"
export * from "./LatestActivity.vue?vue&type=script&lang=js"
import style0 from "./LatestActivity.vue?vue&type=style&index=0&id=437ef930&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports